<template>

    <div :class="this.view == 'row_view' ? 'offers-row' : 'article-wrapper'">

        <div v-if="this.view == 'row_view'" class="row g-0 px-4 mx-2 fs-4 txt-black">
            <div class="col-12 col-md-3 py-3 px-3 offer_row_tile">{{this.offer.Merchant.Name}}</div>
            <div class="col-12 col-md-5 py-3 px-3 offer_row_tile">{{ this.offer.Headline }}</div>
            <div class="col-12 col-md-2 py-3 px-3 text-center"><a href="javascript:;" @click.prevent="showOfferDetailModal" class="txt-black text-decoration-underline">View Details</a></div>

            <div class="col-12 col-md-2 px-3 text-center" v-if="this.offer.ActiveSc == 'AVAILABLE' && !this.activatedNow">
                <a @click="showEnrollCardOrActivate"  :disabled="activating" :class="(activating || show_offer_activation_failed_msg) ? 'button pink tinysize small mTop10 modal-link isDisabled' : 'button pink tinysize small mTop10 modal-link'">{{this.activating ? 'Activating' : 'Activate' }}</a>
                <p class="offerActivationFailedMsg" style="font-size: 1vw" v-if="show_offer_activation_failed_msg">Offer Activation Failed</p>
            </div>
            <div class="col-12 col-md-2 px-3 text-center" v-if="this.offer.ActiveSc != 'AVAILABLE' || this.activatedNow">
                <a href="javascript:" class="button pink activated tinysize small mTop10 modal-link">Activated</a>
            </div>

        </div>

        <article v-if="this.view != 'row_view'" class="content-article" :style="cssVars"  style="position:relative">

            <figure class="featured">
                <img class="redemption_logo" :src="getRedemptionTypeLogo">
                <span  class="img-name" :style="{ backgroundImage: 'url(' + image + ')' }"></span>
            </figure>
            <div class="article-info" v-if="this.offer">
                <p>{{this.offer.Headline }}</p>

                <div v-if="this.offer.ActiveSc == 'AVAILABLE' && !this.activatedNow">
                    <a href="javascript:;" @click="showEnrollCardOrActivate" :disabled="activating" :class="activating ? 'button pink midsize small mTop10 modal-link isDisabled' : 'button pink midsize small mTop10 modal-link'">{{this.activating ? 'Activating' : 'Activate' }}</a>
                    <p class="offerActivationFailedMsg" style="font-size: 1vw" v-if="show_offer_activation_failed_msg"> Offer Activation Failed</p>
                </div>
                <div v-if="(this.offer.ActiveSc != 'AVAILABLE' || this.activatedNow) && (this.offer.OfferProvider != 'rewards_network')">
                    <a :href="getActivatedButtonTextOrUrl('href')" target="_blank" :class="getActivatedButtonTextOrUrl('text') == 'Shop Now' ? 'button orange midsize small mTop10 modal-link' : 'button pink midsize small mTop10 modal-link'">{{getActivatedButtonTextOrUrl('text')}}</a>
                </div>

                <div v-if="(this.offer.ActiveSc != 'AVAILABLE' || this.activatedNow) && (this.offer.OfferProvider == 'rewards_network')">
                  <div class="address_block">
                      {{ getMerchantInfo('street') }}<br>
                      {{ getMerchantInfo('city_state_zip') }}
                  </div>
                </div>

                <div class="my-3">
                    <a href="javascript:;" @click.prevent="showOfferDetailModal" class="txt-grey fs-5">View details</a>
                </div>
            </div>

            <div class="expiry_date_activated_block">
                <div class="expires expired_block">
                    <div class="expires_label">
                        Expires
                    </div>
                    <div v-if="isNaN(this.offer.EventEndDate)" class="expiry_date">
                       {{ formattedEndDate }}
                    </div>
                    <div v-if="!isNaN(this.offer.EventEndDate)" class="expiry_date">
                        <span v-if="this.offer.EventEndDate == 1">today</span>
                        <span v-if="this.offer.EventEndDate != 1">
                            {{ 'in ' + this.offer.EventEndDate }}
                        <span v-if="this.offer.EventEndDate > 1">days</span>
                        <span v-if="this.offer.EventEndDate == 1">day</span>
                    </span>
                    </div>
                </div>
                <div class="activated_block"  v-if="this.offer.ActiveSc != 'AVAILABLE' || this.activatedNow">
                    <font-awesome-icon  icon="fa-solid fa-circle-check" />     Activated
                </div>
           </div>

        </article>

        <offer-details-component
            v-if="showDetailModal && this.offer && this.offer.OfferProvider != 'rewards_network'"
            @reload="reload"
            @reloadOffer ="reloadOffer"
            @showEnrollCardOrActivate="showEnrollCardOrActivate"
            :activatedNow="this.activatedNow"
            :offer="this.offer"
            :show_offer_activation_failed_msg="show_offer_activation_failed_msg"
        >
        </offer-details-component>

        <offer-calendar-details-component
            v-if="showDetailModal && this.offer && this.offer.OfferProvider == 'rewards_network'"
            @reload="reload"
            @reloadOffer ="reloadOffer"
            @showEnrollCardOrActivate="showEnrollCardOrActivate"
            :activatedNow="this.activatedNow"
            :offer="this.offer"
            :show_offer_activation_failed_msg="show_offer_activation_failed_msg"
        >
        </offer-calendar-details-component>

        <enroll-cards-component v-if="showEnrollModal"  :modalId="this.offer.OfferId" @reloadOffer ="reloadOffer" @reload = "reload" :offer="this.offer"></enroll-cards-component>
    </div>
</template>

<script>
import OfferCalendarDetailsComponent from './modals/OfferCalendarDetailsComponent.vue';
import OfferDetailsComponent from './modals/OfferDetailsComponent.vue';
import EnrollCardsComponent from './modals/EnrollCardsComponent.vue';
import moment from "moment";
export default {
  components: { OfferDetailsComponent, OfferCalendarDetailsComponent, EnrollCardsComponent },
    name: "OffersBlockComponent",
    props: ['offer', 'view', 'email_offer_activation', 'bcn'],
    data() {
        return {
            user: null,
            userEnrolledInAll: this.getUserEnrolledInAll(),
            activatedNow: false,
            activating: false,
            show_offer_activation_failed_msg:false,
            showEnrollModal:false,
            showDetailModal:false,
            image: this.offer && this.offer.hasOwnProperty('MerchantImageURL') ? this.offer.MerchantImageURL : '../images/placeholder.jpg',
        }
    },
    computed: {
        formattedEndDate() {
            return (this.offer && this.offer.EventEndDate) ? moment(this.offer.EventEndDate).format('MM/DD/YYYY') : 'N/A';
        },
        cssVars() {
            let col = '#F26B1C';
            if(this.offer && this.offer.RedemptionType) {
                switch(this.offer.RedemptionType) {

                    case 'ONLINE':
                        col = '#E70157';
                        break;

                    case 'INSTORE':
                        col = '#F26B1C';
                        break;

                    case 'ONLINE-INSTORE':
                        col = '#6F1855';
                        break;

                    default:
                }
            }

            return {
                '--color': col
            }
        },
        getRedemptionTypeLogo() {
            let img = '';
            if(this.offer && this.offer.RedemptionType) {
                switch(this.offer.RedemptionType) {

                    case 'ONLINE':
                        img = 'images/online.png';
                        break;

                    case 'INSTORE':
                        img = 'images/in_store.png';
                        break;

                    case 'ONLINE-INSTORE':
                        img = 'images/both.png';
                        break;

                    default:
                }
            }
            return img;
        },
    },
    methods: {
        getMerchantInfo(info) {
            let ret = 'N/A';
            if(this.offer ?. Merchant ?. Addresses ?. Address) {
                let innerObj = this.offer.Merchant.Addresses.Address[0];
                switch (info) {

                    case 'street':
                        if(innerObj.Street) {
                            ret = innerObj.Street;
                        }
                        break;

                    case "city_state_zip":
                        if(innerObj.city) {
                            ret = innerObj.city + ', ' + innerObj.state + ' '+ innerObj.zip_code;
                        }
                        break;

                    default:
                        break;
                }
            }

            return ret;
        },
        activate() {
            if(this.offer.OfferId) {
                this.activating = true;
                this.show_offer_activation_failed_msg = false;
                axios.post(this.apiEndPoints.activateOffer, {
                    offer_id: this.offer.OfferId
                }).then(response => {
                        if (response.data && response.data.ActivationId) {
                            if(response.data.Status && response.data.Status == 'ACTIVATED') {
                                this.activatedNow = true;
                                this.offer.EventEndDate = response.data.RedemptionEndDate;
                                /**
                                 * emit a global event, so that if the same offer is rendered any where else on DOM, we mark it activated as well.
                                 */
                                this.$eventHub.$emit('offer_activated_' + this.offer.OfferId, this.offer.OfferId);
                            } else {
                                this.activatedNow = false;
                            }
                        } else {
                            this.show_offer_activation_failed_msg = true;
                        }
               }).catch(error => {
                    this.show_offer_activation_failed_msg = true;
                    if (error.response && error.response.status && (error.response.status == 401 || error.response.status == 419)) {
                        this.$router.push({name : 'sign_in'});
                    }

                    return false;
                }).finally(()=> {
                    this.activating = false;
                });
            }

        },

        showOfferDetailModal() {

            if(this.bcn && this.email_offer_activation) {
                let routeData = this.$router.resolve({name: 'email-activation', query: {bcn: this.bcn, offer_id: this.offer.OfferId, mode: 'view'}});
                window.open(routeData.href, '_self');
            } else {
                this.resetValues();
                this.showDetailModal = true;
            }
        },

        reload(user) {
           this.user = user;
           this.userEnrolledInAll = this.getUserEnrolledInAll();
           this.activatedNow = true;
        },

        reloadOffer(offer) {
            if(offer.RedemptionEndDate) {
                this.offer.EventEndDate = offer.RedemptionEndDate;
            }
        },

        getUserEnrolledInAll() {
            if(localStorage.getItem('user_obj')) {
                this.user = JSON.parse(localStorage.getItem('user_obj'));
            }
            return (this.user && this.user.id && this.user.total_aggregators_enrolled_in == this.user.total_aggregators_count && this.user.total_aggregators_count > 0);
        },

        resetValues() {
            this.showEnrollModal = false;
            this.showDetailModal = false;
        },

        showEnrollCardOrActivate() {

            if(this.bcn && this.email_offer_activation) {
                let routeData = this.$router.resolve({name: 'email-activation', query: {bcn: this.bcn, offer_id: this.offer.OfferId}});
                window.open(routeData.href, '_self');
            } else {
                this.userEnrolledInAll = this.getUserEnrolledInAll();
                if (this.userEnrolledInAll) {
                    this.activate();
                } else {
                    this.resetValues();
                    this.showEnrollModal = true;
                }
            }
        },
        getActivatedButtonTextOrUrl(arg) {
            let ret = '';
            if(this.offer && this.offer.RedemptionType) {
                switch(this.offer.RedemptionType) {

                    case 'ONLINE':
                    case 'ONLINE-INSTORE':
                        ret =  (arg == 'href') ? ((this.offer.Merchant && this.offer.Merchant.WebsiteUrl) ? this.offer.Merchant.WebsiteUrl: 'javascript:;') : 'Shop Now';
                        break;

                    case 'INSTORE':
                        ret =  (arg == 'href') ? ((this.offer.Merchant && this.offer.Merchant.StoreLocatorUrl) ? this.offer.Merchant.StoreLocatorUrl: 'javascript:;') : 'Find a Store';
                        break;

                    default:
                        ret =  (arg == 'href') ? 'javascript:;' : 'Activated';
                        break
                }
            }

            return ret;
        },
    },
    updated () {

      if(this.showEnrollModal) {
          $.colorbox({
              inline: true,
              href: '#enroll-cards-modal-' + this.offer.OfferId,
              width: '80%',
              maxWidth: '800px',
              opacity: '0.90',
              closeButton: false,
              onComplete: function () {
                  setTimeout(function () {
                      $.colorbox.resize();
                  }, 500);
              }
          });
          $('.modal-close').on('click', function (e) {
              e.preventDefault();
              $.colorbox.close();
          });
      }

      if(this.showDetailModal) {
          $.colorbox({
              inline: true,
              href: this.offer.OfferProvider != 'rewards_network' ? '#offer-details-modal-' + this.offer.OfferId : '#offer-calendar-modal-' + this.offer.OfferId,
              width: '80%',
              maxWidth: '800px',
              opacity: '0.90',
              closeButton: false,
              onComplete: function () {
                  setTimeout(function () {
                      $.colorbox.resize();
                  }, 500);
              }
          });
          $('.modal-close').on('click', function (e) {
              e.preventDefault();
              $.colorbox.close();
          });
      }
    },
    mounted() {
        if(localStorage.getItem('user_obj')) {
            this.user = JSON.parse(localStorage.getItem('user_obj'));
        }

        this.$eventHub.$on('offer_activated_'+this.offer.OfferId, (offerId) => {
            if(offerId == this.offer.OfferId) {
                this.activatedNow = true;
            }
        });
    },
    beforeDestroy() {
        this.$eventHub.$off('emit_from_map_'+this.offer.OfferId);
        this.$eventHub.$off('offer_activated_'+this.offer.OfferId);
    },
}
</script>

<style scoped>
    .isDisabled {
      pointer-events: none;
    }

    .onlineOfferLink {
        font-weight: bold;
        color:#3d85f2;
        /*text-decoration:underline;*/
        font-size: 1.6rem;
    }
    .offerActivationFailedMsg{
        color: #eb2d2e;
        font-size: 1vw;
        padding: 0.5vw;
    }

    .offer_row_tile {

    }
    .activated_block {
        border-top-left-radius: 0.7vw;
        position:absolute;
        right:0;
        bottom:0;
        background-color:#7cc7a1;
        padding:1.5rem;
        font-weight:bolder;
        color:#336600;
    }
    .address_block {
        font-size: 1.5rem;
        font-weight: bolder;
        color: black;
    }
    @media screen and (max-width: 600px){
        .offer_row_tile {
            text-align: center;
        }
        .activated_block {
            border-top-left-radius: 2vw;
            position:absolute;
            right:0;
            bottom:0;
            background-color:#7cc7a1;
            padding:1.5rem;
            font-weight:bolder;
            color:#336600;
        }
    }

    .redemption_logo {
        position:absolute;
        top: -6.3%;
        left: -3.8%;
        z-index:99999;
        width:32%
    }

    .expired_block
    {
        position:absolute;
        bottom:3%;
        left:3%
    }

    .expires_label {
        font-size:1.3rem;
        color:#E70157;
        font-weight:bolder
    }

    .expiry_date {
        color:black;
        font-weight:bold
    }

    .expiry_date_activated_block {
        margin:8%
    }

    </style>


